import { authContextFromSessionIdentity } from "@crm/access/auth/session-auth";
import {
  anonymousAuthContext,
  failedAuthContext,
  pendingAuthContext,
} from "@crm/access/auth/state";
import type { AuthContext } from "@crm/access/types/router";
import type { AuthSessionWire } from "@crm/rpc-contract/groups/session";

export type SsrSessionResult =
  | { readonly _tag: "Timeout" }
  | { readonly _tag: "Failure"; readonly message: string }
  | {
      readonly _tag: "Success";
      readonly session: AuthSessionWire | null | undefined;
    };

export function authContextFromSsrSessionResult(result: SsrSessionResult): AuthContext {
  switch (result._tag) {
    case "Timeout":
      return pendingAuthContext();
    case "Failure":
      return failedAuthContext(result.message);
    case "Success": {
      if (result.session === undefined) return pendingAuthContext();
      if (result.session === null) return anonymousAuthContext();
      return authContextFromSessionIdentity(result.session.user);
    }
  }
}
